import BottomSheetContent from '../../../components/BottomSheetComponents/BottomSheetContent'

type ReinvestLowerAmountBottomSheetProps = {
  onDismiss: () => void
}

export default function ReinvestLowerAmountBottomSheet({ onDismiss }: ReinvestLowerAmountBottomSheetProps) {
  return (
    <BottomSheetContent
      heading='Why is the amount to reinvest lower than withdrawal amount?'
      onDismiss={onDismiss}
      bottomSheetBodyClassName='!px-5'
    >
      <div className='text-[14px] font-normal leading-[150%] space-y-4 pb-4 text-[#6A6E6E]'>
        <p>
          The suggested reinvestment amount is lower because exit load is applied when you withdraw from this fund.
        </p>

        <p>
          This fee is deducted by the fund house at the time of redemption, so the amount you receive in your account (and reinvest) will be lower than the withdrawal amount.
        </p>

        <p>
          We only recommend withdrawals where the tax benefit is significantly higher than the exit load.
        </p>
      </div>
    </BottomSheetContent>
  )
}

